import { isEmpty } from "utils/validationUtil";
import {
  MAX_PROJECT_CODE_LENGTH,
  MAX_PROJECT_DESCRIPTION_LENGTH,
  MAX_PROJECT_NAME_LENGTH,
} from "AppConstants";

/**
 * Per-field messages for the Add/Edit Project dialog, which renders each one under the field
 * it belongs to. Shaped like ACTIVITY_FIELD_MESSAGES in activityValidationUtil.js.
 *
 * @since NEXT_VERSION
 */
export const CLIENT_PROJECT_FIELD_MESSAGES = {
  clientId: { required: "Select a client." },
  code: {
    required: "Enter a code.",
    tooLong: `Use at most ${MAX_PROJECT_CODE_LENGTH} characters.`,
  },
  name: {
    required: "Enter a project name.",
    tooLong: `Use at most ${MAX_PROJECT_NAME_LENGTH} characters.`,
  },
  description: {
    tooLong: `Use at most ${MAX_PROJECT_DESCRIPTION_LENGTH} characters.`,
  },
};

/**
 * Client, code and name are required; description is optional. Returns which field failed
 * rather than a single boolean, so the dialog can mark the offending field instead of
 * reporting one message for the whole form.
 *
 * Lengths match the column widths in client_schema._project so a value the server would
 * truncate or reject never leaves the dialog. The inputs also cap typing at those lengths,
 * so the tooLong messages are a backstop rather than the usual path.
 *
 * @since NEXT_VERSION
 */
export const validateClientProject = (projectObject) => {
  const fieldErrors = {};
  const project = projectObject ?? {};

  if (isEmpty(project.clientId)) {
    fieldErrors.clientId = CLIENT_PROJECT_FIELD_MESSAGES.clientId.required;
  }

  if (isEmpty(project.code)) {
    fieldErrors.code = CLIENT_PROJECT_FIELD_MESSAGES.code.required;
  } else if (project.code.length > MAX_PROJECT_CODE_LENGTH) {
    fieldErrors.code = CLIENT_PROJECT_FIELD_MESSAGES.code.tooLong;
  }

  if (isEmpty(project.name)) {
    fieldErrors.name = CLIENT_PROJECT_FIELD_MESSAGES.name.required;
  } else if (project.name.length > MAX_PROJECT_NAME_LENGTH) {
    fieldErrors.name = CLIENT_PROJECT_FIELD_MESSAGES.name.tooLong;
  }

  if (
    !isEmpty(project.description) &&
    project.description.length > MAX_PROJECT_DESCRIPTION_LENGTH
  ) {
    fieldErrors.description = CLIENT_PROJECT_FIELD_MESSAGES.description.tooLong;
  }

  return { isValid: Object.keys(fieldErrors).length === 0, fieldErrors };
};
